import { useMemo } from 'react';
import type { FilterMatrixRow, FilterState } from '../types';
import {
  deriveFilterAvailability,
  type FilterAvailability,
} from '../utils/deriveFilterTrees';

// Memoised wrapper around `deriveFilterAvailability` so the four maps only
// recompute when a filter that actually feeds the matrix predicate changes.
// `query` and `prefix` correctly cause no recompute since the matrix has no
// text, so they can't shape facet availability.
//
// Returns null while the matrix is still loading; consumers should treat
// null as "no narrowing applied — render every node enabled".
export function useFilterAvailability(
  matrix: FilterMatrixRow[] | null,
  filters: FilterState,
): FilterAvailability | null {
  const {
    einzelplan,
    kapitel,
    expenditureType,
    subExpType,
    funktion,
    oberfunktion,
    hauptfunktion,
    gruppierung,
    obergruppe,
    hauptgruppe,
  } = filters;

  return useMemo(() => {
    if (!matrix) return null;
    return deriveFilterAvailability(matrix, filters);
    // Filters destructured into primitive deps so the memo invalidates on
    // real value changes; eslint can't see through the destructure.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    matrix,
    einzelplan,
    kapitel,
    expenditureType,
    subExpType,
    funktion,
    oberfunktion,
    hauptfunktion,
    gruppierung,
    obergruppe,
    hauptgruppe,
  ]);
}
